module.exports = __webpack_public_path__ + "img/badge-completed-trainings.a3bb08ff.svg";